import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import {
  Action,
  Store
} from "@ngrx/store";
import {
  of
} from "rxjs";
import {
  catchError,
  exhaustMap,
  map,
  mergeMap,
  tap
} from "rxjs/operators";
import {
  ServiceProviderInformationResponseModel
} from "../../domain";
import { ServiceProviderService } from "../../service/service-provider.service";
import * as ServiceProviderInfoAction from "./service-provider-info.action";
import { ServiceProviderInfoActionTypes } from "./service-provider-info.action";

@Injectable()
export class ServiceProviderInfoEffect {

  getServiceProviderInfo$ = createEffect(() => this.actions$.pipe(
    ofType<ServiceProviderInfoAction.GetServiceProviderInfo>(ServiceProviderInfoActionTypes.GetServiceProviderInfo),
    exhaustMap(() =>
      this.serviceProviderService.getServiceProviderInfo().pipe(
        map((data: ServiceProviderInformationResponseModel) => new ServiceProviderInfoAction.ServiceProviderInfoSuccess(data)),
        catchError((err: HttpErrorResponse) => of(new ServiceProviderInfoAction.ServiceProviderInfoFault(err.message)))
      )
    )
  )
  );

  constructor(private actions$: Actions, private store$: Store<any>, private serviceProviderService: ServiceProviderService) {
  }
}
